// extracted by mini-css-extract-plugin
module.exports = {"variables":"'../../stylesheet/vars.css'","secondaryBackgroundColor":"rgba(39, 39, 39, 0.2)","Overlay":"Modal_Overlay__3_Q4P"};